import { OverridesStyleRules } from '@mui/material/styles/overrides';

import type { CustomTheme } from '@/theme/theme.types';

export const MUI_SWITCH: OverridesStyleRules = {
    MuiSwitch: {
        defaultProps: {},
        styleOverrides: {
            root: ({ theme }: { theme: CustomTheme }) => ({
                width: 28,
                height: 16,
                padding: 0,
                display: 'flex',
                '&:active': {
                    '& .MuiSwitch-thumb': {
                        width: 15,
                    },
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        transform: 'translateX(0.9rem)',
                    },
                },
                '& .MuiSwitch-switchBase': {
                    padding: '0.3rem',
                    '&.Mui-checked': {
                        transform: 'translateX(1.4rem)',
                        color: theme.palette.common.white,
                        '& + .MuiSwitch-track': {
                            opacity: 1,
                            backgroundColor: theme.palette.statistics.green,
                        },
                    },
                },
                '& .MuiSwitch-thumb': {
                    boxShadow: '0 0.2rem 0.4rem 0 rgb(0 35 11 / 20%)',
                    width: 8,
                    height: 8,
                    borderRadius: 6,
                    transition: theme.transitions.create(['width'], {
                        duration: 200,
                    }),
                },
                '& .MuiSwitch-track': {
                    borderRadius: 16 / 2,
                    opacity: 1,
                    backgroundColor: theme.palette.muted.muted2,
                    boxSizing: 'border-box',
                },
            }),
        },
    },
};
